module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921102334_T.ba654c4c.jpg";